export default "__VITE_ASSET__QttvZV5Q__"